module.exports = __webpack_public_path__ + "static/axe-bdbe96abf282471e92a01fc82d72e815.png";